import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-procurement-parent',
    templateUrl: './procurement-parent.component.html',
    styleUrls: ['./procurement-parent.component.scss'],
    standalone: false
})
export class ProcurementParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
